import { getEmojiBaseUrl } from '../emoji/utils';
import '../emoji';
import '../code-tag';
import '../link';
import { defineCustomElement, NectaryElement, getLiteralAttribute, updateLiteralAttribute, getAttribute, updateAttribute, parseMarkdown } from '../utils';
const templateHTML = '<style>:host{display:block;--sinch-comp-rich-text-font:var(--sinch-sys-font-body-m)}:host([size="s"]){--sinch-comp-rich-text-font:var(--sinch-sys-font-body-s)}:host([size=xs]){--sinch-comp-rich-text-font:var(--sinch-sys-font-body-xs)}:host([size=xxs]){--sinch-comp-rich-text-font:var(--sinch-sys-font-body-xxs)}#wrapper{font:var(--sinch-comp-rich-text-font);color:var(--sinch-global-color-text,var(--sinch-sys-color-text-default))}.em1{font-style:italic}.em2{font-weight:var(--sinch-ref-typography-font-weight-700)}.strikethrough{text-decoration:line-through}.link{font:var(--sinch-comp-link-default-font-initial);color:var(--sinch-comp-link-color-default-text-initial);text-decoration:underline}.link:hover{color:var(--sinch-comp-link-color-default-text-hover);text-decoration:none}.code{font:var(--sinch-comp-code-tag-font-text);line-height:inherit;font-size:inherit;border:1px solid var(--sinch-comp-code-tag-color-default-border-initial);background-color:var(--sinch-comp-code-tag-color-default-background-initial);padding:0 .25em;border-radius:var(--sinch-comp-code-tag-shape-radius)}.emoji{--sinch-global-size-icon:1em;--sinch-comp-emoji-vertical-align:-0.2em}.ol,.p,.ul{margin:0}.ol,.ul{padding-left:1.5em}.ol+.p,.p+.ol,.p+.p,.p+.ul,.ul+.p{margin-top:.5em}.li>.p+.ol,.li>.p+.ul{margin-top:0}</style><div id="wrapper"></div>';
import { createParseVisitor, sizeValues } from './utils';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-rich-text', class extends NectaryElement {
  #wrapper;
  #parseVisitor;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    if (typeof shadowRoot.createElement !== 'function') {
      Object.defineProperty(shadowRoot, 'createElement', {
        value: document.createElement.bind(shadowRoot.ownerDocument)
      });
    }
    Object.defineProperty(shadowRoot, 'createTextNode', {
      value: document.createTextNode.bind(shadowRoot.ownerDocument)
    });
    Object.defineProperty(shadowRoot, 'createDocumentFragment', {
      value: document.createDocumentFragment.bind(shadowRoot.ownerDocument)
    });
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#wrapper = shadowRoot.querySelector('#wrapper');
    this.#parseVisitor = createParseVisitor(shadowRoot);
  }
  connectedCallback() {
    super.connectedCallback();
    this.role = 'paragraph';
    this.#parseVisitor.updateEmojiBaseUrl(getEmojiBaseUrl(this));
    this.#updateText();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  static get observedAttributes() {
    return ['text'];
  }
  attributeChangedCallback(name, _oldVal, _newVal) {
    switch (name) {
      case 'text':
        {
          this.#updateText();
          break;
        }
    }
  }
  get size() {
    return getLiteralAttribute(this, sizeValues, 'size', 'm');
  }
  set size(value) {
    updateLiteralAttribute(this, sizeValues, 'size', value);
  }
  get text() {
    return getAttribute(this, 'text', '');
  }
  set text(value) {
    updateAttribute(this, 'text', value);
  }
  #updateText() {
    if (!this.isDomConnected) {
      return;
    }
    const text = this.text;
    if (text === null) {
      this.#wrapper.innerHTML = '';
    } else {
      this.#wrapper.replaceChildren(parseMarkdown(text, this.#parseVisitor.createVisitor()));
    }
  }
});